import {getCanvasAppParentOrigin} from '@packages/utilities/canvas-origin';

/**
 * Sends message to Designer app with data that should be reported DataDog RUM
 *
 * Note: This is temporary solution that we use to be able to observe Canvas App behavior
 * We might want to add Canvas app as a separate observable application in the DataDog RUM, though this will complicate
 * observing how the Canvas app is interacting with the Designer app.
 */
export const telemetrySendEvent = ({
  name,
  data,
}: {
  name: string;
  data?: Record<string, any>;
}) => {
  const message = {
    method: 'telemetry.sendEvent',
    name: `canvasApp - ${name}`,
    data,
  };
  const designerAppOrigin = getCanvasAppParentOrigin(window);

  if (designerAppOrigin) {
    window.parent.postMessage(message, designerAppOrigin);
  }
};

/**
 * Sends message to Designer app with error that should be reported DataDog RUM
 */
export const telemetrySendError = ({
  name,
  error,
}: {
  name: string;
  error: Error;
}) => {
  const data = error.message;

  const message = {
    method: 'telemetry.sendError',
    name: `canvasApp - ${name}`,
    data,
  };
  const designerAppOrigin = getCanvasAppParentOrigin(window);

  if (designerAppOrigin) {
    window.parent.postMessage(message, designerAppOrigin);
  }
};
